import { createContext } from 'react';

import {} from './webview-bridge.type';
import type { WebviewBridgeContextValue } from './webview-bridge-context.type';

export const WebviewBridgeContext = createContext<WebviewBridgeContextValue | undefined>(undefined);
